/* === AgSwitch — Anagogia Design System === */

import styles from './AgSwitch.module.css';

interface AgSwitchProps {
  /** Controlled checked state */
  checked?: boolean;
  /** Uncontrolled default */
  defaultChecked?: boolean;
  /** Called with the new checked value */
  onChange?: (checked: boolean) => void;
  size?: 'sm' | 'md';
  color?: 'primary' | 'secondary';
  disabled?: boolean;
  /** Optional label rendered next to the switch */
  label?: React.ReactNode;
  className?: string;
}

const COLOR_MAP: Record<string, string> = {
  primary: styles.colorPrimary,
  secondary: styles.colorSecondary,
};

/**
 * Interrupteur marche/arrêt.
 * @category Formulaires
 */
function AgSwitch({
  checked,
  defaultChecked,
  onChange,
  size = 'md',
  color = 'primary',
  disabled = false,
  label,
  className,
}: AgSwitchProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.checked);
  };

  const wrapperCls = [
    styles.wrapper,
    disabled ? styles.disabled : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const trackCls = [styles.track, styles[size], COLOR_MAP[color]]
    .filter(Boolean)
    .join(' ');

  return (
    <label className={wrapperCls}>
      <span className={styles.switchContainer}>
        <input
          type="checkbox"
          className={styles.input}
          checked={checked}
          defaultChecked={defaultChecked}
          onChange={handleChange}
          disabled={disabled}
          role="switch"
          aria-checked={checked}
        />
        <span className={trackCls}>
          <span className={styles.thumb} />
        </span>
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
}

export { AgSwitch };
export type { AgSwitchProps };
export default AgSwitch;
